import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ModalService, ToastService } from '../../blocks';

import { takeUntil } from 'rxjs/operators'; import { Subject } from 'rxjs';
import { UserSessionService } from '../../shared';
import { BankTransformer } from '../../banks/Bank-Transformer/bank-transformer.service';
import { BankTransformerDiscountService } from './bank-transformmer-discount.service';

@Component({
    selector: 'bank-transformer-discount',
    templateUrl: './bank-transformmer-discount.commponent.html',
})
export class BankTransformerDiscountComponent implements OnInit, OnDestroy {
    BankTransformer: BankTransformer[];
    transType: number = 1;
    benfType: number = 2;
    benfCode: number = 0;
    totalValue: number = 0
    currencyCode: number = 0;
    factor: number = 0;
    bankTransformerDiscountParms: any
    private ngUnsubscribe: Subject<void> = new Subject<void>();
    constructor(
        private _BankTransformerService: BankTransformerDiscountService,
        private _route: ActivatedRoute,
        private _router: Router,
        private _toastService: ToastService,
        private _userSessionService: UserSessionService,
        public translate: TranslateService,
        private _modalService: ModalService
    ) { }

    ngOnInit() {
       
        if (this._userSessionService.getModalKey('BankTransformerDiscountComponent')) {
            this.bankTransformerDiscountParms = this._userSessionService.getModalKey('BankTransformerDiscountComponent')["inputs"];
            this.benfCode = this.bankTransformerDiscountParms.benfCode
            this.benfType = this.bankTransformerDiscountParms.benfType
            this.transType = this.bankTransformerDiscountParms.transType
            this.totalValue = +this.bankTransformerDiscountParms.totalValue;
            this.currencyCode = this.bankTransformerDiscountParms.currencyCode;
            this.factor = this.bankTransformerDiscountParms.factor;
            this.getBankTransformer()
            // this.remainingValue = this.supplierObj.remainingValue;
        }

        this._userSessionService.getModalKey$().pipe(
            takeUntil(this.ngUnsubscribe))
            .subscribe((keys: any) => {
                this.bankTransformerDiscountParms = <any>{};
                if (keys.name == 'BankTransformerDiscountComponent' && keys.inputs) {
                   
                    this.bankTransformerDiscountParms = keys.inputs;
                    this.benfCode = this.bankTransformerDiscountParms.benfCode
                    this.benfType = this.bankTransformerDiscountParms.benfType
                    this.transType = this.bankTransformerDiscountParms.transType
                    this.totalValue = this.bankTransformerDiscountParms.totalValue
                    this.currencyCode = this.bankTransformerDiscountParms.currencyCode;
                    this.factor = this.bankTransformerDiscountParms.factor;
                    this.getBankTransformer()
                    // this.remainingValue = keys.inputs.remainingValue;
                }
            });

    }

    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }

    getBankTransformer() {
        this.BankTransformer = [];
        this._BankTransformerService.getBankTransformerDiscount(this.benfType, this.transType, this.benfCode,this.currencyCode)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(
                res => {
                    if (res && res.data) {
                       
                        this.BankTransformer = res.data;
                        if (this.totalValue == 0) {
                            this.BankTransformer.forEach(element => {
                                this.totalValue = +this.totalValue + (+element.remainingValue)
                            });
                        }

                    }
                },
                error => console.log(error),
                () => {
                    null
                });

    }
    OncurrentValueChange(row: BankTransformer) {
        let rr: number = 0
        rr = row.remainingBefore - row.payedValue
        if (rr >= 0) {
            row.remainingValue = rr
        } else {
            row.payedValue = 0
            this._toastService.activateMsg('UI13');

        }
    }
    save() {
       
        let bankTransformerarray: BankTransformer[] = [];
        let totalDiscountBankTransfere = 0
        for (let i = 0; i < this.BankTransformer.length; i++) {
            if (this.BankTransformer[i].payedValue > 0) {
                bankTransformerarray.push(this.BankTransformer[i])
                totalDiscountBankTransfere = +totalDiscountBankTransfere + (+this.BankTransformer[i].payedValue)
            }

        }
        // if (this.totalDeduction > this.remainingValue) {
        if (+totalDiscountBankTransfere > +this.totalValue) {
            this._toastService.activateMsg('UI13');
            totalDiscountBankTransfere = 0;
        }
        else {
            this._userSessionService.closeModalKey('BankTransformerDiscountComponent', bankTransformerarray);
        }


    }
}
